export const getDataLine = (e) => {
    let table = $('table').DataTable(),
        rowIndex = e.currentTarget.parentNode.parentNode['_DT_RowIndex'],
        data = table.row(rowIndex).data();
    return {table: table, rowIndex: rowIndex, data: data}
};


// WEBPACK FOOTER //
// ./assets/js/utils_dataTables.js